@if (isLoading()) {
  <mat-progress-bar mode="query" />
}

<mat-toolbar class="app-header">
  <a href="/" class="logo-wrapper">
    <img src="assets/smd-logo.jpg" alt="Logo" class="logo" />
  </a>

  @if (isAuthenticated()) {
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>person</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <div mat-menu-item>
        <div class="account-info name">{{ account()?.name }}</div>
      </div>
      <mat-divider />
      <button mat-menu-item (click)="switchAccount()">Byt konto</button>
      <button mat-menu-item (click)="logout()">Logga ut</button>
    </mat-menu>
  }
</mat-toolbar>

  <mat-toolbar class="page-navbar">
    @if (title() != null) {
    <div class="page-navbar-content">
      <button mat-icon-button (click)="onNavBackClick()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2>{{ title() }}</h2>
    </div>
    }
  </mat-toolbar>

<div class="content">
  <router-outlet (activate)="onRouteActivated($event)" />
</div>

<footer>
  @if (!prodEnv) {
    <div>Dev (DevOps)</div>
  }
</footer>
